module.exports = require("core-js-pure/stable/number/parse-float");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/number/parse-float.js
// module id = 1923
// module chunks = 25